import { render, staticRenderFns } from "./notificationModal.vue?vue&type=template&id=5857d2b0&"
import script from "./notificationModal.vue?vue&type=script&lang=js&"
export * from "./notificationModal.vue?vue&type=script&lang=js&"
import style0 from "./notificationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports